import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FormattedMessage, useIntl } from "react-intl";
import style from "./FirstPersonAvatarPreview.scss";
import cartoonAvatarImage from "../../assets/images/avatar-previews/cartoon_avatar.png";
import { AvatarPreviewPopover } from "./AvatarPreviewPopover";
import { Button, Spinner } from "@fluentui/react-components";
import { useModalContext } from "./ModalContext";
import { EditNameModal } from "./EditNameModal";
import notificationsCenter from "../../singleton/NotificationsCenter";

export function FirstPersonAvatarPreview({
  signedIn,
  profile,
  isAbsolute,
  showContextualSignInDialog,
  onEditAvatar,
  onSignOut,
  store
}) {
  const intl = useIntl();

  const { showNonHistoriedDialog, closeDialog } = useModalContext();

  const handleSaveName = displayName => {
    const previousDisplayName = profile.displayName;

    store.update({
      profile: {
        ...profile,
        displayName
      },
      activity: {
        ...store.state.activity,
        hasChangedName: true
      }
    });

    notificationsCenter.success(
      intl.formatMessage({
        id: "room-settings-sidebar.name-saved",
        defaultMessage: "Name updated successfully"
      })
    );

    APP.messageDispatch.push(
      {
        oldName: previousDisplayName,
        newName: displayName
      },
      "display_name_changed"
    );
  };

  const handleEditName = () => {
    showNonHistoriedDialog(EditNameModal, {
      profile,
      onSave: handleSaveName,
      onClose: closeDialog
    });
  };

  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    window.APP.scene.addEventListener("fetching_auth_user", () => {
      setIsFetching(true);
    });
    window.APP.scene.addEventListener("fetching_auth_user_end", () => {
      setIsFetching(false);
    });

    return () => {
      window.APP.scene.removeEventListener("fetching_auth_user", () => setIsFetching(true));
      window.APP.scene.removeEventListener("fetching_auth_user_end", () => setIsFetching(false));
    };
  }, []);

  useEffect(() => {
    if (signedIn) {
      setIsFetching(false);
    }
  }, [signedIn]);

  const [open, setOpen] = useState(false);

  return (
    <div className={classNames(style.firstPersonAvatarPreview, { [style.absolute]: isAbsolute })}>
      {signedIn && profile.thumbnail && (
        <AvatarPreviewPopover
          image={profile?.thumbnail || cartoonAvatarImage}
          name={profile.displayName}
          onEditAvatar={onEditAvatar}
          onSignOut={onSignOut}
          onEditName={handleEditName}
          open={open}
          setOpen={setOpen}
        />
      )}
      {!signedIn && !isFetching && (
        <Button appearance="primary" size="small" onClick={showContextualSignInDialog}>
          <FormattedMessage id="sign-in-button" defaultMessage="Sign in" />
        </Button>
      )}
      {!signedIn && isFetching && <Spinner size="large" appearance="primary" />}
    </div>
  );
}

FirstPersonAvatarPreview.propTypes = {
  signedIn: PropTypes.bool,
  profile: PropTypes.object,
  customStyle: PropTypes.string,
  isAbsolute: PropTypes.bool,
  onClick: PropTypes.func,
  showContextualSignInDialog: PropTypes.func,
  onEditAvatar: PropTypes.func,
  onSignOut: PropTypes.func,
  store: PropTypes.object
};
